import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../CustomHooks/useApi";
import MerchantTxnAdminHistory from "./MerchantTxnAdminHistory";
import Modal from "../../ResuableCompoment/Modal";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

/* ============================= */
/*   NEW HIERARCHY HEADINGS      */
/* ============================= */

const HIERARCHY_COLUMNS = [
    "National Head",
    "Zonal Head",
    "RSM",
    "SH",
    "ASM",
    "Master Distributor",
    "Distributor",
    "Retailer",
    "Independent Retailer",
];

const AdminHierarchyTreeTable = () => {
    /* ============================= */
    /*        DATE FUNCTIONS         */
    /* ============================= */

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const getToday = () => formatDate(new Date());


    const [summaryLoading, setSummaryLoading] = useState(true);


    const getMinAllowedDate = () => {
        const today = new Date();
        const lastMonth = new Date(today);
        lastMonth.setMonth(today.getMonth() - 1);
        return formatDate(lastMonth);
    };

    const rootMobile = useSelector(
        (state) => state.auth.employeeDetails?.mobile_number
    );

    const [fromDate, setFromDate] = useState(getToday());
    const [toDate, setToDate] = useState(getToday());

    const MIN_DATE = getMinAllowedDate();
    const MAX_DATE = getToday();


    const handleSearch = () => {
        const from = new Date(fromDate);
        const to = new Date(toDate);

        const diffDays = (to - from) / (1000 * 60 * 60 * 24);

        if (diffDays > 31) {
            alert("Download only one month data. Older data ke liye contact admin.");
            return;
        }

        fetchHierarchy(currentMobile);
        fetchBusinessSummary();// ✅ only here
    };
    const { callApi: hierarchy } = useApi("/hierarchy/v2/list", "GET");
    const { callApi: businessSummary } = useApi(
        "/hierarchy/v2/summary",
        "GET"
    );
    const { callApi: searchHierarchy } = useApi("/hierarchy/v2/search", "GET");

    const [currentMobile, setCurrentMobile] = useState(null);
    const [hierarchyData, setHierarchyData] = useState([]);
    const [path, setPath] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [selectedMid, setSelectedMid] = useState(null);
    const [selectedService, setSelectedService] = useState(null);
    const [summary, setSummary] = useState(null);



    /* ============================= */
    /*            INIT               */
    /* ============================= */

    useEffect(() => {
        if (rootMobile) {
            setCurrentMobile(rootMobile);
            setPath([]);
        }
    }, [rootMobile]);

    // Hierarchy
    useEffect(() => {
        if (currentMobile) {
            fetchHierarchy(currentMobile);
        }
    }, [currentMobile]);

    // Business Summary
    useEffect(() => {

            fetchBusinessSummary();

    }, [])

    // const fetchBusinessSummary = async () => {
    //     try {
    //         setLoading(true);

    //         const res = await businessSummary(
    //             null,
    //             `?fromDate=${fromDate}&toDate=${toDate}`
    //         );

    //         setSummary(res); // 👈 store karo

    //     } catch (err) {
    //         setError("Failed to load business summary");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const fetchBusinessSummary = async () => {
        try {
            setSummaryLoading(true);

            const res = await businessSummary(
                null,
                `?fromDate=${fromDate}&toDate=${toDate}`
            );

            setSummary(res);
        } catch (err) {
            setError("Failed to load business summary");
        } finally {
            setSummaryLoading(false);
        }
    };

    
    const formatAmount = (value) => {
        const num = Number(value);

        if (isNaN(num)) return "₹0.00";

        return `₹${num.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

    /* ============================= */
    /*        FETCH HIERARCHY        */
    /* ============================= */

    const fetchHierarchy = async (mobile) => {
        setLoading(true);
        setError("");

        try {
            const res = await hierarchy(
                null,
                `?mobile=${mobile}&fromDate=${fromDate}&toDate=${toDate}`
            );

            if (Array.isArray(res)) {
                setHierarchyData(res);  // ✅ STORE RESPONSE HERE
            } else {
                setHierarchyData([]);
            }

            setSelectedMid(null);
            setSelectedService(null);

        } catch (err) {
            setError("Failed to load hierarchy");
        } finally {
            setLoading(false);
        }
    };

    const amt = (v) => `₹${Number(v || 0).toFixed(2)}`;


    /* ============================= */
    /*         EXCEL DOWNLOAD        */
    /* ============================= */


    const downloadExcel = async () => {
        try {
            const filteredData = filteredHierarchy;

            if (!filteredData.length) {
                alert("No merchant data found");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const ws = workbook.addWorksheet("Hierarchy");

            const headers = [
                "National Head", "Zonal Head", "RSM", "SH", "ASM",
                "Master Distributor", "Distributor", "Retailer", "Independent Merchant",

                "T-DMT", "Y-DMT", "M-DMT",
                "T-AEPS", "Y-AEPS", "M-AEPS",
                "T-Recharge", "Y-Recharge", "M-Recharge",
                "T-Payout", "Y-Payout", "M-Payout",
                "T-CreditCard", "Y-CreditCard", "M-CreditCard",

                "T-Total", "Y-Total", "M-Total",
                "Main", "AEPS Balance", "Commission"
            ];

            /* ================= HEADER ================= */
            const headerRow = ws.addRow(headers);

            headerRow.eachCell((cell) => {
                cell.font = { bold: true, color: { argb: "FF000000" } };

                // 🟡 Yellow header
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFFFEB3B" }
                };

                cell.alignment = { horizontal: "center", vertical: "middle" };

                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
            });

            /* ================= DATA ================= */
            filteredData.forEach((row) => {
                ws.addRow([
                    row.nh || "",
                    row.zh || "",
                    row.rsm || "",
                    row.sh || "",
                    row.asm || "",
                    row.md || "",
                    row.distributor || "",
                    row.role === "MERCHANT" ? row.merchant : "",
                    row.role === "INDEPENDENT_MERCHANT" ? row.nameWithMobile : "",

                    row.dmt || 0,
                    row.ydmt || 0,
                    row.mdmt || 0,

                    row.aeps || 0,
                    row.yaeps || 0,
                    row.maeps || 0,

                    row.recharge || 0,
                    row.yrecharge || 0,
                    row.mrecharge || 0,

                    row.payout || 0,
                    row.ypayout || 0,
                    row.mpayout || 0,

                    row.creditCard || 0,
                    row.ycreditCard || 0,
                    row.mcreditCard || 0,

                    row.total || 0,
                    row.yesterday || 0,
                    row.monthTotal || 0,

                    row.mainBalance || 0,
                    row.aepsBalanceWallet || 0,
                    row.commissionBalance || 0,
                ]);
            });

            /* ================= STYLING (SKIP HEADER) ================= */
            ws.eachRow((row, rowNumber) => {

                if (rowNumber === 1) return; // ❗ VERY IMPORTANT

                row.eachCell((cell, colNumber) => {

                    // 🔠 Bold all text
                    cell.font = { bold: true };

                    // 📦 Borders
                    cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    };

                    // 🎨 Section Colors

                    // NH → ASM
                    if (colNumber <= 5) {
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFE3F2FD" }
                        };
                    }

                    // Distributor → Merchant
                    else if (colNumber <= 9) {
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFE8F5E9" }
                        };
                    }

                    // Transactions
                    else if (colNumber <= 24) {
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFFFF3E0" }
                        };
                    }

                    // Totals / Balance
                    else {
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFFFCDD2" }
                        };
                    }

                    // 💰 Right align numbers
                    if (typeof cell.value === "number") {
                        cell.alignment = { horizontal: "right" };
                    }
                });
            });

            /* ================= WIDTH ================= */
            ws.columns.forEach(col => col.width = 20);

            /* ================= FREEZE HEADER ================= */
            ws.views = [{ state: "frozen", ySplit: 1 }];

            const buffer = await workbook.xlsx.writeBuffer();

            saveAs(
                new Blob([buffer]),
                `Hierarchy_${fromDate}.xlsx`
            );

        } catch (err) {
            console.error(err);
            alert("Excel download failed");
        }
    };


    const filteredHierarchy = hierarchyData.filter((row) => {
        const searchText = search.toLowerCase();

        if (!row.leaf) return false;

        return (
            row.nh?.toLowerCase().includes(searchText) ||
            row.zh?.toLowerCase().includes(searchText) ||
            row.rsm?.toLowerCase().includes(searchText) ||
            row.sh?.toLowerCase().includes(searchText) ||
            row.asm?.toLowerCase().includes(searchText) ||
            row.md?.toLowerCase().includes(searchText) ||
            row.distributor?.toLowerCase().includes(searchText) ||
            row.merchant?.toLowerCase().includes(searchText) ||
            row.nameWithMobile?.toLowerCase().includes(searchText)
        );
    });

    /* ============================= */
    /*            RENDER             */
    /* ============================= */

    return (
        <div className="p-6 max-w-[1800px] mx-auto space-y-5">
            

          {/* ══ BUSINESS SUMMARY CARDS & SKELETON LOADER ══ */}
            {summaryLoading ? (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 animate-pulse">
                    {[
                        { title: "Today", border: "border-green-200", bg: "bg-green-50/60" },
                        { title: "Yesterday", border: "border-yellow-200", bg: "bg-yellow-50/60" },
                        { title: "Month", border: "border-blue-200", bg: "bg-blue-50/60" },
                        { title: "Custom", border: "border-purple-200", bg: "bg-purple-50/60" }
                    ].map((card, idx) => (
                        <div key={idx} className={`${card.bg} border ${card.border} p-4 rounded-xl shadow-sm space-y-3`}>
                            {/* Card Header Placeholder */}
                            <div className="flex justify-between items-center pb-1 border-b border-gray-200/50">
                                <span className="h-5 w-24 bg-gray-300/70 rounded-md"></span>
                                {card.title === "Custom" && <span className="h-4 w-28 bg-gray-200 rounded"></span>}
                            </div>
                            
                            {/* Line Items Placeholder */}
                            <div className="space-y-2.5 pt-1">
                                {[1, 2, 3, 4, 5].map((item) => (
                                    <div key={item} className="flex justify-between items-center">
                                        <span className="h-3.5 w-16 bg-gray-200 rounded"></span>
                                        <span className="h-4 w-20 bg-gray-300/80 rounded-md"></span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            ) : summary ? (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

                    {/* TODAY */}
                    <div className="bg-green-50 border border-green-200 p-4 rounded-xl shadow-sm">
                        <h2 className="font-bold text-green-700 text-lg mb-3">Today</h2>

                        {Object.entries(summary.today || {}).map(([key, value]) => (
                            <p key={key} className="flex justify-between text-sm py-1">
                                <span className="capitalize text-gray-600">{key}</span>
                                <span className="font-bold text-base">
                                    {formatAmount(value)}
                                </span>
                            </p>
                        ))}
                    </div>

                    {/* YESTERDAY */}
                    <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-xl shadow-sm">
                        <h2 className="font-bold text-yellow-700 text-lg mb-3">Yesterday</h2>

                        {Object.entries(summary.yesterday || {}).map(([key, value]) => (
                            <p key={key} className="flex justify-between text-sm py-1">
                                <span className="capitalize text-gray-600">{key}</span>
                                <span className="font-bold text-base">
                                    {formatAmount(value)}
                                </span>
                            </p>
                        ))}
                    </div>

                    {/* MONTH */}
                    <div className="bg-blue-50 border border-blue-200 p-4 rounded-xl shadow-sm">
                        <h2 className="font-bold text-blue-700 text-lg mb-3">Month</h2>

                        {Object.entries(summary.month || {}).map(([key, value]) => (
                            <p key={key} className="flex justify-between text-sm py-1">
                                <span className="capitalize text-gray-600">{key}</span>
                                <span className="font-bold text-base">
                                    {formatAmount(value)}
                                </span>
                            </p>
                        ))}
                    </div>

                    {/* CUSTOM */}
                    <div className="bg-purple-50 border border-purple-200 p-4 rounded-xl shadow-sm">
                        <div className="flex justify-between items-center mb-3">
                            <h2 className="font-bold text-purple-700 text-lg">Custom</h2>
                            <span className="text-xs font-semibold text-gray-600">
                                {fromDate} → {toDate}
                            </span>
                        </div>

                        {Object.entries(summary.custom || {}).map(([key, value]) => (
                            <p key={key} className="flex justify-between text-sm py-1">
                                <span className="capitalize text-gray-600">{key}</span>
                                <span className="font-bold text-base">
                                    {formatAmount(value)}
                                </span>
                            </p>
                        ))}
                    </div>

                </div>
            ) : null}

            {/* HEADER */}
            {/* <div className="bg-white rounded-2xl shadow border p-5 flex flex-wrap gap-4 justify-between items-end">
                <div>
                    <h1 className="text-xl font-bold">Hierarchy</h1>
                </div>

                <input
                    type="text"
                    placeholder="Search by Name / Mobile..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="border px-3 py-2 rounded-lg text-sm w-[250px]"
                />

                <div className="flex gap-3 flex-wrap items-end">
                    <div>
                        <label className="block text-xs mb-1">From</label>
                        <input
                            type="date"
                            value={fromDate}
                            min={MIN_DATE}
                            max={MAX_DATE}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-xs mb-1">To</label>
                        <input
                            type="date"
                            value={toDate}
                            min={fromDate}   // 🔥 important
                            max={MAX_DATE}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>

                    <button
                        onClick={handleSearch}
                        className="h-[42px] px-6 rounded-lg bg-indigo-600 text-white"
                    >
                        Search
                    </button>

                    <button
                        onClick={downloadExcel}
                        className="h-[42px] px-6 rounded-lg bg-green-600 text-white"
                    >
                        Download Excel
                    </button>
                </div>
            </div>

            {loading && filteredHierarchy.length === 0 && (
                <div className="bg-white rounded-2xl shadow border p-10 flex justify-center items-center">
                    <div className="flex flex-col items-center gap-3">
                        <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                        <p className="text-sm text-gray-700 font-medium">
                            Loading hierarchy...
                        </p>
                    </div>
                </div>
            )} */}

            {/* TABLE */}
            {/* {!loading && filteredHierarchy.length > 0 && (
                <div className="w-full overflow-auto max-h-[75vh] border rounded-xl shadow-sm">
                    <table className="w-full text-sm border-collapse"> */}

                        {/* ✅ Sticky Header */}
                        {/* <thead className="sticky top-0 z-20 bg-gradient-to-r from-slate-800 to-slate-700 text-white">
                            <tr>
                                {HIERARCHY_COLUMNS.map((h) => (
                                    <th
                                        key={h}
                                        className="px-4 py-3 font-semibold text-left border border-slate-600 whitespace-nowrap"
                                    >
                                        {h}
                                    </th>
                                ))}

                                {[
                                    "T-DMT", "Y-DMT", "M-DMT",
                                    "T-AEPS", "Y-AEPS", "M-AEPS",
                                    "T-Recharge", "Y-Recharge", "M-Recharge",
                                    "T-Payout", "Y-Payout", "M-Payout",
                                    "T-Credit", "Y-Credit", "M-Credit",
                                    "T-Total", "Y-Total", "M-Total",
                                    "Main", "AEPS", "Commission"
                                ].map((h) => (
                                    <th
                                        key={h}
                                        className="px-4 py-3 font-semibold text-right border border-slate-600 whitespace-nowrap"
                                    >
                                        {h}
                                    </th>
                                ))}
                            </tr>
                        </thead> */}

                        {/* ✅ Body */}
                        {/* <tbody> */}
                            {/* {filteredHierarchy
                                .filter(row => row.leaf === true)
                                .map((row, i) => (
                                    <tr
                                        key={i}
                                        className={`transition-all duration-200 ${i % 2 === 0 ? "bg-white" : "bg-slate-50"
                                            } hover:bg-blue-50`}
                                    > */}

                                        {/* 🔥 Hierarchy Columns */}
                                        {/* <td className="px-4 py-2 border border-gray-300 font-semibold text-blue-600">{row.nh}</td>
                                        <td className="px-4 py-2 border border-gray-300 font-semibold text-purple-600">{row.zh}</td>
                                        <td className="px-4 py-2 border border-gray-300 font-semibold text-green-600">{row.rsm}</td>
                                        <td className="px-4 py-2 border border-gray-300 font-semibold text-yellow-600">{row.sh}</td>
                                        <td className="px-4 py-2 border border-gray-300 font-semibold text-orange-600">{row.asm}</td>
                                        <td className="px-4 py-2 border border-gray-300 font-semibold text-cyan-600">{row.md}</td>
                                        <td className="px-4 py-2 border border-gray-300 font-semibold text-lime-600">{row.distributor}</td>
                                        <td className="px-4 py-2 border border-gray-300 font-semibold text-gray-800">{row.merchant}</td>
                                        <td className="px-4 py-2 border border-gray-300 font-semibold text-pink-600">{row.independentMerchant}</td> */}

                                        {/* 🔢 Amount Columns */}
                                        {/* <td className="px-4 py-2 text-right border border-gray-300">{amt(row.dmt)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.ydmt)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.mdmt)}</td>

                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.aeps)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.yaeps)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.maeps)}</td>

                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.recharge)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.yrecharge)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.mrecharge)}</td>

                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.payout)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.ypayout)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.mpayout)}</td>

                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.creditCard)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.ycreditCard)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.mcreditCard)}</td> */}

                                        {/* ⭐ Highlight */}
                                        {/* <td className="px-4 py-2 text-right font-bold text-green-600 border border-gray-300">
                                            {amt(row.total)}
                                        </td>

                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.yesterday)}</td>
                                        <td className="px-4 py-2 text-right border border-gray-300">{amt(row.monthTotal)}</td>

                                        <td className="px-4 py-2 text-right border border-gray-300 font-medium text-blue-600">
                                            {amt(row.mainBalance)}
                                        </td>
                                        <td className="px-4 py-2 text-right border border-gray-300 font-medium text-purple-600">
                                            {amt(row.aepsBalanceWallet)}
                                        </td>
                                        <td className="px-4 py-2 text-right border border-gray-300 font-medium text-orange-600">
                                            {amt(row.commissionBalance)}
                                        </td>

                                    </tr>
                                ))}
                        </tbody> */}
                    {/* </table> */}
                {/* </div>
            )} */}

            {/* MODAL */}
            <Modal
                open={Boolean(selectedMid && selectedService)}
                onClose={() => {
                    setSelectedMid(null);
                    setSelectedService(null);
                }}
                title="Merchant Transaction History"
            >
                <MerchantTxnAdminHistory
                    mid={selectedMid}
                    service={selectedService}
                />
            </Modal>
        </div>
    );
};

export default AdminHierarchyTreeTable;